import { AnalyticsEvent } from '@/core/analytics/events/AnalyticsEvent.ts'

interface DatagridViewEventProps extends Record<string, unknown> {
  units?: 'money' | 'quantity'
  mode?: 'categories' | 'plain'
}

class DatagridViewEvent extends AnalyticsEvent {
  constructor(props: DatagridViewEventProps) {
    super('Datagrid View', props)
  }
}

export { DatagridViewEvent }
